import { createUpdateEffect, useIsomorphicLayoutEffect } from "ahooks";
export var useIsomorphicUpdateLayoutEffect = createUpdateEffect(useIsomorphicLayoutEffect);